import '@styles/components/appCivilStationDesigner.less';

const AppVisualReview = () => {
  return (
    <div className={'app-display-desc'}>
      <div>
        <div className={'content-introduction'}>
          方案设计评审系统是跨世纪自主研发，面向公路工程提供基于BIM技术的总体方案设计、方案分析、方案展示和方案评审的解决方案。
        </div>
      </div>
      <div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_01.png').default} alt="" />
          <p className={'qldsimgj'}>现有公路平、纵面</p>
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'title-color'}>
          <span className={'lefttitle-color'}>更高</span>
          <span className={'righttitle-color'}>展示需求</span>
        </div>
        <div className={'introducenew'}>
          <p>现场情况不清晰、设计成果表达不直观</p>
          <p>设计方案修改频繁、设计成本高</p>
          <p>时间、风险等问题</p>
        </div>
        <div className={'line-style'}></div>
        <div className={'title-color'}>
          <span className={'lefttitle-color'}>更好</span>
          <span className={'righttitle-color'}>总体方案</span>
        </div>
        <div className={'introducenew'}>
          <p>空间数据不完善、对现场实际情况不了解</p>
          <p>比选条件、优化空间不足</p>
          <p>项目投资、进度、质量等方面存在较大的优化空间</p>
        </div>
        <div className={'line-style'}></div>
        <div className={'title-color'}>
          <span className={'lefttitle-color'}>突破</span>
          <span className={'righttitle-color'}>传统设计</span>
        </div>
        <div className={'introducenew'}>
          <p>方案表达严重依赖图纸，审核效率低，不环保</p>
          <p>二、三维设计成果后续应用价值挖掘不足</p>
        </div>
        <div className={'line-style'}></div>
        <div className={'title-color'}>
          <span className={'lefttitle-color'}>提升</span>
          <span className={'righttitle-color'}>沟通效率</span>
        </div>
        <div className={'introducenew'}>
          <p>在疫情还未结束的当下，对项目沟通和交流带来了新的挑战</p>
          <p>传统在线会议难以全面，高效表达设计意图，交流受到时空限制</p>
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>总体方案设计</p>
          <span className={'line'} />
        </div>
        <span className={'title-bg-style'}>方案设计展示特点：</span>
        <div className={'introducenew'}>
          <p>1、将设计方案二维表达转换为多维表达模式</p>
          <p>2、多方案比选能力，并具备造价比对功能</p>
          <p>3、能够较好地承接三维设计成果及设计参数，挖掘三维价值</p>
          <p>4、较强的空间分析及模拟能力</p>
          <p>5、多方协同评审在线沟通功能，安全高效开展项目评估与协调</p>
          <p>6、多项目管理能力，多语言版本，高稳定性及安全性</p>
          <p>7、云部署及私有化部署，无网络条件下的系统打包应用</p>
        </div>
        <span className={'title-bg-style'}>方案设计及评审数据应用流程：</span>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_02.png').default} alt="" />
        </div>
        <span className={'title-bg-style'}>方案设计及评审数据应用流程：</span>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_03.png').default} alt="" />
        </div>
      </div>
      <div className={'bg-color'}>
        <div className={'content-title'}>
          <span className={'text'}>方案设计</span>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          基于Bentley OpenRoads
          Designer开发方案设计，可以创建或导入总体方案并快速创建全线总体方案模型，修改优化总体方案、快速核算工程量及造价。
        </div>
        <div className={'introducenew'}>
          方案设计重点突出“建的细、改的快、算量准、价值高”的特点，辅助总体方案设计及优化。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_04.png').default} alt="" />
          <p className={'qldsimgj'}>导入总体设计方案快速创建模型</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_05.png').default} alt="" />
          <p className={'qldsimgj'}>导入立交方案快速创建模型</p>
        </div>
      </div>
      <div>
        <div className={'content-title'}>
          <p className={'text'}>方案分析</p>
          <span className={'line'} />
        </div>
        <div className={'introduce'}>
          采用GIS引擎及BIM引擎双擎融合技术，快速发布主流平台方案模型及设计参数到云端，专家及设计人员可以在网页端评议宏观方案设计成果并校审微观精细化的数字孪生模型。模型发布快捷，浏览顺畅，操作简便。
        </div>
        <div className={'introduce'}>
          通过丰富的智能分析可视化工具，可对淹没边界、区域填挖方、交通流量、征迁面积进行定量及定性分析，辅助优化设计。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_06.png').default} alt="" />
          <p className={'qldsimgj'}>平纵设计数据联动</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_07.png').default} alt="" />
          <p className={'qldsimgj'}>淹没边界分析</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_08.png').default} alt="" />
          <p className={'qldsimgj'}>区域填挖方定量分析</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_09.png').default} alt="" />
          <p className={'qldsimgj'}>交通流模拟辅助定性分析</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_10.png').default} alt="" />
          <p className={'qldsimgj'}>征迁面积定量分析</p>
        </div>
      </div>
      <div className={'bg-color'} style={{ marginBottom: '0px' }}>
        <div className={'content-title'}>
          <span className={'text'}>方案展示、评审</span>
          <span className={'line'} />
        </div>
        <div className={'introducenew'}>
          集成GIS环境、BIM模型、实景模型、外业信息、设计参数、工程量等成果数据，构成多要素、多维度，可视化的方案展示及评审场景。
        </div>
        <div className={'introducenew'}>
          突出“看得清、查得准、评有据、比的全”的功能特点，辅助初设阶段方案展示和经济比选。
          用户可自由查看设计方案，自定义汇报及展示流程，按照定制的流程进行自动汇报并可输出汇报视频。
        </div>
        <div className={'introducenew'}>
          参与方案评审的设计人员及专家可以在web端对设计方案进行在线批注并形成会审意见。
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_11.png').default} alt="" />
          <p className={'qldsimgj'}>征迁面积定量分析</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_12.png').default} alt="" />
          <p className={'qldsimgj'}>多方方案比对</p>
        </div>
        <div className={'text-center'}>
          <img className={'ql_02'} src={require('@images/home/ps_13.png').default} alt="" />
          <p className={'qldsimgj'}>在线互动方案评审</p>
        </div>
      </div>
    </div>
  );
};

export default AppVisualReview;
